import 'stylesheets/global.scss';
import 'stylesheets/components/table.scss';
import 'stylesheets/components/button.scss';
import 'stylesheets/components/page.scss';
import 'stylesheets/components/list.scss';

import React, {Component,PropTypes}     from 'react';
import ReactDOM                         from 'react-dom/server';
import { reduxForm }                    from 'redux-form';
import _                                from 'lodash';
import {intlShape, injectIntl}          from 'react-intl';
import moment                           from 'moment';
import { bindActionCreators }           from 'redux';
import { FormattedMessage }             from 'react-intl';

import * as businessRules  from 'app/businessRules';
import PureRenderComponent from 'app/lib/PureRenderComponent';
import iso6346Check from 'app/lib/iso6346Check';
import {displayDateFormat, serverDateFormat} from 'app/lib/format';
import getFormValues from 'app/lib/getFormValues';

import {VisitForm}              from '../components/VisitForm';
import {getPackagingUnity,getUnitKinds,getTerminals,getVisitIds,getOwnerTransporterId,
        getPrefComp,
        getLicensePlates,getExecutingTransportCompanies, getDocTypes}
                                from 'modules/profile/selectors';
import {hasVisit, getVisit, getTimeSlots, getTimeSlotConfig, getUnitVerification, getGoods, getDocs}
                                from 'modules/visits/selectors';
import {isRequestingResource}   from 'modules/app/selectors';
import * as actionCreators      from 'modules/visits/actions';
const formName = 'visit';


export const fields = [
    'trac',
    'dom',
    'slotEta',
    'timeslot',
    'licensePlate',
    'transId',
    'ownerTransId',
    'status',
    'chassisPlate',
    'chassisType',
    'canSubmit',

    'units[].nhmCode',
    'units[].trac',
    'units[].dim',
    'units[].inOut',
    'units[].netto',
    'units[].rid',
    'units[].empty',
    'units[].status',
    'units[].reasons',
    'units[].reference',
    'units[].pos',
    'units[].unitKind',
    'units[].ctNumber',

    'units[].ISO',

    'units[].good',
    'units[].good.open',
    'units[].good.desc',
    'units[].good.nettoWeight',
    'units[].good.packagingId',
    'units[].good.packagingCount',
    'units[].good.packagingUnity',
    'units[].good.colliId',
    'units[].good.hzd',
    'units[].good.id',
    'units[].good.hzdData.lq',
    'units[].good.hzdData.ridReg',
    'units[].good.hzdData.ridId',
    'units[].good.hzdData.originalHzdId',
    'units[].good.hzdData.hzdId',
    'units[].good.hzdData.unNr',
    'units[].good.hzdData.cls',
    'units[].good.hzdData.packingGroup',
    'units[].good.hzdData.maritime',
    'units[].good.hzdData.environment',
    'units[].good.hzdData.waste',

    'units[].doc',
    'units[].doc.open',
    'units[].doc.id',
    'units[].doc.type',
    'units[].doc.number',
    'units[].doc.regPlace',
    'units[].doc.regDate'
];

const validate = (values) => {
    const err = {
        required: <FormattedMessage id="error.required" />,
        timeSlotFormat: <FormattedMessage id="error.timeSlotFormat" />,
        maxLen12: <FormattedMessage id="error.maxLen" values={{count: 12}} />,
        maxLen35: <FormattedMessage id="error.maxLen" values={{count: 35}} />,
        maxLen15: <FormattedMessage id="error.maxLen" values={{count: 15}} />,
        maxLen5: <FormattedMessage id="error.maxLen" values={{count: 5}} />,
        minLen6: <FormattedMessage id="error.minLen" values={{count: 6}} />,
        minLen3: <FormattedMessage id="error.minLen" values={{count: 3}} />,
        iso6346: <FormattedMessage id="error.iso6346" />,
        number: <FormattedMessage id="error.number" />
    };
    const errors = {};

    // VISIT

    if (!values.dom) {
        errors.dom = err.required;
    }
    if (!values.slotEta) {
        errors.slotEta = err.required;
    }
    if (values.timeslot && !/^([0-9]{2}:[0-9]{2})$|^([0-9]{2}:[0-9]{2}\s?-\s?[0-9]{2}:[0-9]{2})$/.test(values.timeslot)) {
        errors.timeslot = err.timeSlotFormat;
    }
    if (values.licensePlate) {
        if (values.licensePlate.length > 12) {
            errors.licensePlate = err.maxLen12;
        }
        else if (values.licensePlate.length < 6) {
            errors.licensePlate = err.minLen6;
        }
    }
    if (values.chassis) {
        if (values.chassis.length > 12) {
            errors.chassis = err.maxLen12;
        }
    }

    errors.units = errors.units || [];

    // UNIT

    _.each(values.units, (unit, index) => {
        errors.units[index] = errors.units[index] || {};
        errors.units[index].doc = errors.units[index].doc || {};
        errors.units[index].good = errors.units[index].good || {};
        errors.units[index].good.hzdData = errors.units[index].good.hzdData || {};

        if (unit.inOut === 'I') {
            if (!unit.reference) {
                errors.units[index].reference = err.required;
            } else if (unit.reference.length > 35) {
                errors.units[index].reference = err.maxLen35;
            } else if (unit.reference.length < 3) {
                errors.units[index].reference = err.minLen3;
            }
        }

        if (unit.ctNumber) {
            if (unit.ctNumber.length > 15) {
                errors.units[index].ctNumber = err.maxLen15;
            } else if (!iso6346Check(unit.ctNumber)) {
                errors.units[index].ctNumber = err.iso6346;
            }
        }

        if (!unit.empty) {
            if (!unit.netto) {
                errors.units[index].netto = err.required;
            } else if (_.isNaN(parseInt(unit.netto))) {
                errors.units[index].netto = err.number;
            } else if (unit.netto.length > 5) {
                errors.units[index].netto = err.maxLen5;
            }
        }

        // GOOD
        if (unit.good.open) {

            if (!unit.good.desc) {
                errors.units[index].good.desc = {transId:'error.required'}; //We cannot use the FormattedMessage component here, because a Good opens in a modal where its i18n context is lost
            } else if (unit.good.desc.length > 512) {
                errors.units[index].good.desc = {transId:'error.maxLen', values:{count:512}};
            }

            if (!unit.good.nettoWeight) {
                errors.units[index].good.nettoWeight = {transId:'error.required'};
            } else if (_.isNaN(parseInt(unit.good.nettoWeight))) {
                errors.units[index].good.nettoWeight = {transId:'error.number'};
            }

            if (unit.good.packagingId && unit.good.packagingId.length > 35) {
                errors.units[index].good.packagingId = {transId:'error.maxLen', values:{count:35}};
            }

            if (unit.good.packagingCount && unit.good.packagingCount.length > 9) {
                errors.units[index].good.packagingCount = {transId:'error.maxLen', values:{count:9}};
            } else if (unit.good.packagingCount && _.isNaN(parseInt(unit.good.packagingCount))) {
                errors.units[index].good.packagingCount = {transId:'error.number'};
            }

            if (unit.good.colliId && unit.good.colliId.length > 35) {
                errors.units[index].good.colliId = {transId:'error.maxLen', values:{count:35}};
            }

            if (unit.good.hzd) {

                if (unit.good.hzdData.ridId && unit.good.hzdData.ridId.length > 5) {
                    errors.units[index].good.hzdData.ridId = {transId:'error.maxLen', values:{count:5}};
                }

                if (!unit.good.hzdData.unNr) {
                    errors.units[index].good.hzdData.unNr = {transId:'error.required'};
                } else if (unit.good.hzdData.unNr.length > 5) {
                    errors.units[index].good.hzdData.unNr = {transId:'error.maxLen', values:{count:5}};
                }

                if (unit.good.hzdData.cls && unit.good.hzdData.cls.length > 7) {
                    errors.units[index].good.hzdData.cls = {transId:'error.maxLen', values:{count:7}};
                }

                if (unit.good.hzdData.packingGroup && unit.good.hzdData.packingGroup.length > 3) {
                    errors.units[index].good.hzdData.packingGroup = {transId:'error.maxLen', values:{count:3}};
                }

            }
        }

        // DOCUMENT
        if (unit.doc.open) {

            if (unit.doc.number && unit.doc.number.length > 40) {
                errors.units[index].doc.number = {transId:'error.maxLen', values:{count:40}};
            } else if (unit.doc.type && ['ZD', 'GOODS', 'UNIT'].indexOf(unit.doc.type.trim()) === -1 && !unit.doc.number) {
                errors.units[index].doc.number = {transId:'error.required'};
            }

            if (unit.doc.regPlace && unit.doc.regPlace.length > 15) {
                errors.units[index].doc.regPlace = {transId:'error.maxLen', values:{count:15}};
            }

            if (unit.doc.regDate) {
                let parsedDate = moment(unit.doc.regDate, displayDateFormat);
                if (unit.doc.regDate.length !== 10) {
                    errors.units[index].doc.regDate = {transId:'error.dateFormat'};
                } else if (!parsedDate.isValid()) {
                    errors.units[index].doc.regDate = {transId:'error.dateInvalid'};
                } else if ( parsedDate.isAfter(new Date())) {
                    errors.units[index].doc.regDate = {transId:'error.dateFuture'};
                }
            }

        }

    });

    return errors;
};

export class Visit extends PureRenderComponent {

    static propTypes = {
        fields: PropTypes.object.isRequired,
        actions: PropTypes.shape({
            fetchVisitAndUnits: PropTypes.func,
            clearLoadedVisit: PropTypes.func,
            storeVisit: PropTypes.obj,
            storeUnit: PropTypes.obj,
            getTimeSlots: PropTypes.obj,
            verifyUnit: PropTypes.obj,
            getGoods: PropTypes.obj,
            storeGood: PropTypes.obj,
            deleteGood: PropTypes.obj,
            getDocs: PropTypes.obj,
            storeDoc: PropTypes.obj,
            deleteDoc: PropTypes.obj,
            submitVisit: PropTypes.obj
        }),
        handleSubmit: PropTypes.func.isRequired,
        resetForm: PropTypes.func.isRequired,
        submitting: PropTypes.bool.isRequired,
        licensePlates: PropTypes.array,
        unitKinds: PropTypes.array,
        terminals: PropTypes.array,
        params: PropTypes.object,
        visitIds: PropTypes.array,
        packUnity: PropTypes.array,
        loadVisit: PropTypes.func,
        fetchVisit: PropTypes.func,
        timeSlots: PropTypes.object,
        timeSlotConfig: PropTypes.object,
        transCompList: PropTypes.array,
        isLoading: PropTypes.bool,
        intl: intlShape.isRequired,
        chassisTypes: PropTypes.array.isRequired,
        selectedTerminal: PropTypes.shape({
            code: PropTypes.string.isRequired,
            name: PropTypes.string.isRequired,
            days: PropTypes.number.isRequired,
            skipGoodsDocsEntry: PropTypes.bool.isRequired
        })
    };

    constructor(props) {
        super(props);
        this.state = {
            activeUnitIndex: null
        };
        this.addUnitHandler = this.addUnitHandler.bind(this);
        this.removeUnitHandler = this.removeUnitHandler.bind(this);
        this.editUnitHandler = this.editUnitHandler.bind(this);
    }

    componentDidMount() {
        if (this.isEditVisit()) {
            this.props.actions.fetchVisitAndUnits(this.props.params.vtrac);
        } else {
            this.props.actions.clearLoadedVisit();
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.values.dom !== nextProps.values.dom && nextProps.chassisTypes.length > 1) {
            const defaultChassisType = _.find(nextProps.chassisTypes, { 'default': true });
            if (defaultChassisType) {
                this.props.fields.chassisType.onChange(defaultChassisType.id);
            }
        }
    }

    componentDidUpdate(prevProps) {
        if (this.navigatedFromEditToNew(prevProps)) {
            this.props.resetForm();
        }
    }

    navigatedFromEditToNew = (prevProps) => (this.props.route.path.indexOf('new') !== -1 && prevProps.route.path.indexOf('new') === -1);

    isEditVisit = () => (!!this.props.params.vtrac);

    dateChangedHandler = (value) => {
        this.props.fields.slotEta.onChange(value);
        this.props.fields.timeslot.onChange('');
    };

    timeSlotDateChangedHandler = (value) => {
        this.props.fields.slotEta.onChange(value);
    };

    openTimeSlotHandler = () => {
        let parsedDate = moment(this.props.fields.slotEta.value, displayDateFormat);
        let today = moment();

        if (!parsedDate.isValid() || parsedDate.isBefore(today)) {
            parsedDate = today;
        }

        this.props.actions.getTimeSlots.request(parsedDate.format(serverDateFormat), this.props.fields.dom.value);
    };

    /* -----------------------------
     * UNITS
     * ----------------------------- */

    addUnitHandler() {
        this.setState({ activeUnitIndex: this.props.fields.units.length });
        this.props.fields.units.addField(businessRules.defaultUnitFieldValues);
    }

    removeUnitHandler(trac) {
        // let index = _.findIndex(this.props.fields.units, (u) => u.trac.value === trac );
        this.setState({ activeUnitIndex: null });
        // this.props.fields.units.removeField(index);

        this.props.actions.deleteUnit.request(this.props.fields.trac.value, trac);
    }

    editUnitHandler(trac) {
        let index = _.findIndex(this.props.fields.units, (u) => u.trac.value === trac );
        this.setState({ activeUnitIndex: index });
    }

    saveUnitHandler = (values) => {
        let unit = values.units[this.state.activeUnitIndex];
        unit.vtrac = values.trac;
        unit.unitKind = this.getUnitKindFromCode(unit.unitKind);
        unit.dim = this.getDimFromDesc(unit.dim);
        this.props.actions.storeUnit.request(unit);
    };

    getUnitKindFromCode = (code) => {
        return _.find(this.props.unitKinds, {code: code});
    };

    getDimFromDesc = (desc) => {
        if (!desc) {
            return this.props.unitVerification.dims[0];
        }
        const dim = _.find(this.props.unitVerification.dims, {desc});
        return dim || desc;
    };

    getActiveUnit = () => {
        const {fields:{units}} = this.props;
        return this.state.activeUnitIndex !== null ? units[this.state.activeUnitIndex] : null;
    };

    verifyUnitHandler = (unit) => {
        let u = getFormValues(unit);
        u.unitKind = this.getUnitKindFromCode(u.unitKind);
        delete u.dim;
        this.props.actions.verifyUnit.request(u, this.props.fields.dom.value);
    };

    closeUnitFormHandler = () => {
        this.props.actions.verifyUnit.reset();
        this.props.actions.docsAndGoods.clear();
    };

    openUnitFormHandler = (unit) => {
        unit.trac.value &&
            this.props.actions.getGoods.request({trac:unit.trac.value}) &&
            this.props.actions.getDocs.request({trac:unit.trac.value});
    };

    /* -----------------------------
     * GOODS
     * ----------------------------- */
    saveGoodHandler = (trac, values) => {
        this.props.actions.storeGood.request(trac, _.find(values.units, {trac}).good);
    };

    /* -----------------------------
     * DOCS
     * ----------------------------- */
    saveDocHandler = (trac, values) => {
        this.props.actions.storeDoc.request(trac, _.find(values.units, {trac}).doc);
    };


    /* -----------------------------
     * VISIT
     * ----------------------------- */

    saveDraftHandler = (values) => {
        this.props.actions.storeVisit.request(values);
    };

    getChassisTypes = () => {
        // const terminalCode = this.props.values.dom;
        // const terminal = _.find(this.props.terminals, { code: terminalCode });
        // return terminal.chassisTypes || [];
    };

    render() {

        const {handleSubmit, intl, selectedTerminal, ...rest} = this.props;
        const activeUnit = this.getActiveUnit();

        return (
            <VisitForm isEdit={!!this.props.params.vtrac}
                       addUnit={this.addUnitHandler}
                       saveUnit={() => handleSubmit(this.saveUnitHandler)(...arguments)}
                       removeUnit={this.removeUnitHandler}
                       editUnit={this.editUnitHandler}
                       dateChanged={this.dateChangedHandler}
                       onTimeSlotDateChange={this.timeSlotDateChangedHandler}
                       formatMessage={intl.formatMessage}
                       saveDraft={(props) => {handleSubmit(this.saveDraftHandler)(props);}}
                       activeUnit={activeUnit}
                       fields={this.props.fields}
                       verifyUnit={this.verifyUnitHandler}
                       onOpenUnitForm={this.openUnitFormHandler}
                       onCloseUnitForm={this.closeUnitFormHandler}
                       saveGood={(trac) => handleSubmit(this.saveGoodHandler.bind(this, trac))(...arguments)}
                       deleteGood={this.props.actions.deleteGood.request}
                       submitVisit={this.props.actions.submitVisit.request}
                       saveDoc={(trac) => handleSubmit(this.saveDocHandler.bind(this, trac))(...arguments)}
                       deleteDoc={this.props.actions.deleteDoc.request}
                       getDocs={this.props.actions.getDocs.request}
                       onOpenTimeSlot={this.openTimeSlotHandler}
                       chassisTypes={this.getChassisTypes()}
                       skipGoodsDocsEntry={selectedTerminal ? selectedTerminal.skipGoodsDocsEntry : false}
                {...rest} />

        );
    }

}


function mapStateToProps(state) {
    let timeSlots = getTimeSlots(state),
        timeSlotConfig = getTimeSlotConfig(state),
        licensePlates = getLicensePlates(state),
        visitIds = getVisitIds(state),
        terminals = getTerminals(state),
        unitKinds = getUnitKinds(state),
        docTypes = getDocTypes(state),
        transCompList = getExecutingTransportCompanies(state),
        packUnity = getPackagingUnity(state),
        isLoading = isRequestingResource(state, 'visit'),
        isSubmitting = isRequestingResource(state, 'storeVisit'),
        unitVerification = getUnitVerification(state),
        goods = getGoods(state),
        docs = getDocs(state),
        initialValues = {};

    const selectedTerminal = _.find(terminals, { code: state.getIn(['form', 'visit', 'dom', 'value'])});
    const chassisTypes = _.get(selectedTerminal, 'chassisTypes') || [];

    if (hasVisit(state)) {
        initialValues = getVisit(state);
    } else {
        let ownerTransId = getOwnerTransporterId(state);
        let prefCompId = getPrefComp(state);
        if (transCompList.length) {
            let foundPrefTrans = _.find(transCompList, ['code', prefCompId]);
            prefCompId = foundPrefTrans ? prefCompId : transCompList[0].code;
        }
        initialValues = {
            dom: terminals.length && terminals[0].code,
            transId: prefCompId,
            ownerTransId: ownerTransId,
            licensePlate: state.get('profile').get('licensePlate') || licensePlates[0],
            status: 'Draft'
        };
    }

    return {
        initialValues,
        licensePlates,
        terminals,
        visitIds,
        timeSlots,
        timeSlotConfig,
        packUnity,
        isLoading,
        isSubmitting,
        unitKinds,
        transCompList,
        unitVerification,
        docTypes,
        goods,
        docs,
        chassisTypes,
        selectedTerminal
    };
}

function mapDispatchToProps(dispatch) {
    let actions = bindActionCreators(actionCreators, dispatch);
    actions.storeVisit = bindActionCreators(actionCreators.storeVisit, dispatch);
    actions.storeUnit = bindActionCreators(actionCreators.storeUnit, dispatch);
    actions.deleteUnit = bindActionCreators(actionCreators.deleteUnit, dispatch);
    actions.getTimeSlots = bindActionCreators(actionCreators.getTimeSlots, dispatch);
    actions.verifyUnit = bindActionCreators(actionCreators.verifyUnit, dispatch);
    actions.getGoods = bindActionCreators(actionCreators.getGoods, dispatch);
    actions.storeGood = bindActionCreators(actionCreators.storeGood, dispatch);
    actions.deleteGood = bindActionCreators(actionCreators.deleteGood, dispatch);
    actions.getDocs = bindActionCreators(actionCreators.getDocs, dispatch);
    actions.storeDoc = bindActionCreators(actionCreators.storeDoc, dispatch);
    actions.deleteDoc = bindActionCreators(actionCreators.deleteDoc, dispatch);
    actions.submitVisit = bindActionCreators(actionCreators.submitVisit, dispatch);
    actions.docsAndGoods = bindActionCreators(actionCreators.docsAndGoods, dispatch);

    return {
        actions
    };
}

export const VisitContainer = reduxForm({
    form: formName,
    fields,
    validate,
    getFormState: (state, reduxMountPoint) => state.get(reduxMountPoint).toJS()
},
mapStateToProps,
mapDispatchToProps
)(injectIntl(Visit));
